import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-person-table-jica",
  templateUrl: "./table-jica.component.html",
  styleUrls: ["./table-jica.component.css"],
})
export class PersonTableJicaComponent {
  @Input() datalist: any[] = [];
  @Input() isLoaded: boolean;
  @Input() mendan_flg: number;
  @Input() person_all_select: boolean;
  @Input() editItem: any;
  @Input() page: number;
  @Input() display_per_page: number;
  @Input() ROLE: any;
  @Input() usersService: any;

  // 全てのボタンアクションを親に通知するための口
  @Output() onSelectAll = new EventEmitter<boolean>();
  @Output() onSelectP = new EventEmitter<any>();
  @Output() onPreview = new EventEmitter<any>();
  @Output() onAnswerEdit = new EventEmitter<any>();
  @Output() onGoOutputSingle = new EventEmitter<any>();
  @Output() onOpenFileModal = new EventEmitter<any>();
  @Output() onYoyakuAccept = new EventEmitter<any>();
  @Output() onYoyakuAcceptCancel = new EventEmitter<any>();
  @Output() onYoyakuMemo = new EventEmitter<any>();
  @Output() onYoyakuEdit = new EventEmitter<{ y: any; d: any }>();
  @Output() onYoyakuProperty = new EventEmitter<any>();
  @Output() onYoyakuCancel = new EventEmitter<any>();
  @Output() onEditPerson = new EventEmitter<any>();
  @Output() onGoMail = new EventEmitter<any>();

  // HTMLから呼ばれる中継メソッド
  selectedAllChange(val: boolean) {
    this.onSelectAll.emit(val);
  }
  selectP(d: any) {
    this.onSelectP.emit(d);
  }
  preview(y: any) {
    this.onPreview.emit(y);
  }
  answerEdit(y: any) {
    this.onAnswerEdit.emit(y);
  }
  goOutputSingle(y: any) {
    this.onGoOutputSingle.emit(y);
  }
  openFileModal(d: any) {
    this.onOpenFileModal.emit(d);
  }
  yoyakuAccept(y: any) {
    this.onYoyakuAccept.emit(y);
  }
  yoyakuAcceptCancel(y: any) {
    this.onYoyakuAcceptCancel.emit(y);
  }
  yoyakuMemo(y: any) {
    this.onYoyakuMemo.emit(y);
  }
  yoyakuEdit(y: any, d: any) {
    this.onYoyakuEdit.emit({ y, d });
  }
  yoyakuProperty(y: any) {
    this.onYoyakuProperty.emit(y);
  }
  yoyakuCancel(y: any) {
    this.onYoyakuCancel.emit(y);
  }
  edit_person(d: any) {
    this.onEditPerson.emit(d);
  }
  goMail(d: any) {
    this.onGoMail.emit(d);
  }
}



// WEBPACK FOOTER //
// ./src/app/a0108-person/table/jica/table-jica.component.ts